import { Link } from 'react-router-dom';
import { Avatar, Dropdown, Menu } from 'antd';
import ApiService from '../../services/ApiService';
import DataService from '../../services/DataService';
import SessionService from '../../services/SessionService';
import { getDropdownMenuItems } from './data';
import { Logo, StyledHeader, StyledHeaderRight } from './styles';

export const AppHeader = ({ initial, headerMenuItems }) => {
  const menuItems = getDropdownMenuItems();

  const handleClickMenuItem = async ({ key }) => {
    switch (key) {
      case 'logout':
        DataService.clear();
        try {
          await ApiService.stopPlayingAllSimulationCountries();
        } catch (e) {
          // Stale locks still expire after 5 minutes.
        }
        SessionService.logout();
        break;
      default:
    }
  };

  return (
    <StyledHeader>
      <Link to="/">
        <Logo>
          Simpolicon<span style={{ fontSize: 20 }}>©2026</span>
        </Logo>
      </Link>
      <StyledHeaderRight>
        <Menu theme="dark" mode="horizontal" items={headerMenuItems} disabledOverflow />
        <Dropdown
          placement="bottomRight"
          trigger={['click']}
          menu={{
            items: menuItems,
            onClick: handleClickMenuItem,
          }}
        >
          <a href="/" onClick={e => e.preventDefault()}>
            <Avatar size="large" style={{ marginLeft: 16, backgroundColor: '#1890FF' }}>
              {initial}
            </Avatar>
          </a>
        </Dropdown>
      </StyledHeaderRight>
    </StyledHeader>
  );
};
